module.exports = __webpack_public_path__ + "img/LBN.502adade.svg";